import styled from "styled-components"
import { mobile, mobilePortrait, tablet, smallScreen } from "../../Responsive"

export const Container = styled.div`
    background-color: ${({ theme }) => theme.body};
`

export const Wrapper = styled.div`
    margin-top: 100px;
    padding: 20px;
    min-height: 85vh;

    ${tablet({ marginTop: "80px"})}
    ${mobile({ marginTop: "60px", padding: "10px"})}
    ${mobilePortrait({ marginTop: "40px"})}
`

export const UserWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px;
`

export const TitleWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

export const Title = styled.h1`
    font-weight: 200;
    margin-bottom: 20px;

    @media screen and (max-width: ${smallScreen}) {
        font-size: var(--fontL);
    }
`

export const Display = styled.div`
    display: flex;
    justify-content: space-between;

    ${tablet({ flexDirection: "column" })}    
`

export const DisplayLeft = styled.div`
    border: 1.5px solid var(--secondary);
    border-radius: 10px;
    margin: 20px 20px 20px 0px;
    padding: 20px;
    flex: 1;

    ${tablet({ margin: "10px 0px" })}
`

export const DisplayRight = styled.div`
    border: 1.5px solid var(--secondary);
    border-radius: 10px;
    margin: 20px 0px 20px 20px;
    padding: 20px;
    flex: 2;

    ${tablet({ margin: "10px 0px" })}
`

export const Update = styled.div`
    border: 1.5px solid var(--secondary);
    border-radius: 10px;
    margin-top: 20px;
    padding: 20px;
`

export const DisplayTop = styled.div`
    display: flex;
    align-items: center;
`

export const DisplayInfo = styled.div`
    display: flex;
    justify-content: space-between;

    ${mobile({ flexDirection: "column" })}
`

export const DisplayBottom = styled.div`
    margin-top: 20px;
`

export const UserImage = styled.img`
    height: 40px;
    width: 40px;
    border-radius: 50%;
    object-fit: cover;
`

export const UserTitle = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 20px;
`

export const UserName = styled.span`
    font-weight: 600;
`

export const UserJob = styled.span`
    font-weight: 300;
`

export const UserDetailsTitle = styled.span`
    font-size: var(--fontS);
    font-weight: 600;
`

export const UserDetails = styled.div`
    display: flex;
    align-items: center;
    margin: 20px 0px;
`

export const UserDetailsIcon = styled.span`
    font-size: var(--fontS) !important;
    color: var(--secondary);
`

export const UsersDetailsInfo = styled.span`
    margin-left: 10px;
`

export const Form = styled.form`
`
export const StyledInputs = styled.div`
    display: flex;
    flex-wrap: wrap;
`

export const FormItem = styled.div`
    width: 400px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 15px;
    margin-right: 20px;

    ${tablet({ width: "300px" })}
    ${mobile({ width: "250px" })}
`

export const StyledSelect = styled.select`
    width: 400px;
    color-scheme: ${({ theme }) => theme.name};
    height: 30px;
    border-radius: 5px;

    ${tablet({ width: "300px" })}
    ${mobile({ width: "250px" })}
`

export const StyledOption = styled.option`
`

export const StyledLabel = styled.label`
    margin-bottom: 5px;
`

export const StyledInput = styled.input`
    background-color: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    font-size: var(--fontS);
    border: none;
    border-bottom: 1px solid var(--primary);
    border-radius: 5px;
    height: 30px;

    ::placeholder { 
        color: ${({ theme }) => theme.text};
    }

    :focus{
        border-bottom: 1px solid var(--secondary);
        outline: none;
    }
`

export const Message = styled.div`
    margin-top: 20px;
    color: var(--secondary);
`

export const FavoriteProducts = styled.div`
    border: 1.5px solid var(--secondary);
    border-radius: 10px;
    margin: 20px 0px;
    padding: 20px;

    ${tablet({ margin: "10px 0px" })}
`